
import GwPageContainer from '~/patterns/molecules/page-container/page-container.vue';
export default {
    components: {
        GwPageContainer
    },
    props: {
        label: {
            type: String,
            default: ''
        }
    }
};
